window.jQuery = require('jquery');
window.$ = window.jQuery;
require('jquery-ui/dist/jquery-ui.js');

window.JSZip = require("jszip");

window.Globalize = require("globalize");

require("globalize/dist/globalize/message");
require("globalize/dist/globalize/number");
require("globalize/dist/globalize/date");

window.Globalize.load(

  require('cldr-data/main/en/ca-gregorian.json'),
  require('cldr-data/main/en/numbers.json'),
  require('cldr-data/main/en/currencies.json'),
  require('cldr-data/main/en/dateFields.json'),
  require('cldr-data/main/en/timeZoneNames.json'),

  require('cldr-data/main/tr/ca-gregorian.json'),
  require('cldr-data/main/tr/numbers.json'),
  require('cldr-data/main/tr/currencies.json'),
  require('cldr-data/main/tr/dateFields.json'),
  require('cldr-data/main/tr/timeZoneNames.json'),

  require('cldr-data/main/de/ca-gregorian.json'),
  require('cldr-data/main/de/numbers.json'),
  require('cldr-data/main/de/currencies.json'),
  require('cldr-data/main/de/dateFields.json'),
  require('cldr-data/main/de/timeZoneNames.json'),

  require('cldr-data/main/ar/ca-gregorian.json'),
  require('cldr-data/main/ar/numbers.json'),
  require('cldr-data/main/ar/currencies.json'),
  require('cldr-data/main/ar/dateFields.json'),
  require('cldr-data/main/ar/timeZoneNames.json'),

  require('cldr-data/main/az/ca-gregorian.json'),
  require('cldr-data/main/az/numbers.json'),
  require('cldr-data/main/az/currencies.json'),
  require('cldr-data/main/az/dateFields.json'),
  require('cldr-data/main/az/timeZoneNames.json'),

  require('cldr-data/main/en-GB/ca-gregorian.json'),
  require('cldr-data/main/en-GB/numbers.json'),
  require('cldr-data/main/en-GB/currencies.json'),
  require('cldr-data/main/en-GB/dateFields.json'),
  require('cldr-data/main/en-GB/timeZoneNames.json'),

  require('cldr-data/main/en-US-POSIX/ca-gregorian.json'),
  require('cldr-data/main/en-US-POSIX/numbers.json'),
  require('cldr-data/main/en-US-POSIX/currencies.json'),
  require('cldr-data/main/en-US-POSIX/dateFields.json'),
  require('cldr-data/main/en-US-POSIX/timeZoneNames.json'),

  require('cldr-data/main/el/ca-gregorian.json'),
  require('cldr-data/main/el/numbers.json'),
  require('cldr-data/main/el/currencies.json'),
  require('cldr-data/main/el/dateFields.json'),
  require('cldr-data/main/el/timeZoneNames.json'),

  require('cldr-data/main/ru/ca-gregorian.json'),
  require('cldr-data/main/ru/numbers.json'),
  require('cldr-data/main/ru/currencies.json'),
  require('cldr-data/main/ru/dateFields.json'),
  require('cldr-data/main/ru/timeZoneNames.json'),

  require('cldr-data/main/es/ca-gregorian.json'),
  require('cldr-data/main/es/numbers.json'),
  require('cldr-data/main/es/currencies.json'),
  require('cldr-data/main/es/dateFields.json'),
  require('cldr-data/main/es/timeZoneNames.json'),

  require('cldr-data/main/uz/ca-gregorian.json'),
  require('cldr-data/main/uz/numbers.json'),
  require('cldr-data/main/uz/currencies.json'),
  require('cldr-data/main/uz/dateFields.json'),
  require('cldr-data/main/uz/timeZoneNames.json'),

  require('cldr-data/main/fr/ca-gregorian.json'),
  require('cldr-data/main/fr/numbers.json'),
  require('cldr-data/main/fr/currencies.json'),
  require('cldr-data/main/fr/dateFields.json'),
  require('cldr-data/main/fr/timeZoneNames.json'),

  require('cldr-data/supplemental/likelySubtags.json'),
  require('cldr-data/supplemental/timeData.json'),
  require('cldr-data/supplemental/weekData.json'),
  require('cldr-data/supplemental/currencyData.json'),
  require('cldr-data/supplemental/numberingSystems.json')

);

var dxMessages = require("../../libs/dx-localization/dx.messages.all.json");

if (dxMessages.messages["en"] && !dxMessages.messages["en-GB"]) {
    dxMessages.messages["en-GB"] = dxMessages.messages["en"];
}
if (dxMessages.messages["en"] && !dxMessages.messages["en-US-POSIX"]) {
    dxMessages.messages["en-US-POSIX"] = dxMessages.messages["en"];
}

window.Globalize.loadMessages(dxMessages.messages);